import { gate } from 'hub-http/gates';
export const PersistPromiseGate = gate('CDVM:PersistPromise');